import _slicedToArray from "/home/gitlab-runner/builds/9s43Yg6F/0/frontend/bb-official/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/gitlab-runner/builds/9s43Yg6F/0/frontend/bb-official/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/gitlab-runner/builds/9s43Yg6F/0/frontend/bb-official/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/gitlab-runner/builds/9s43Yg6F/0/frontend/bb-official/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["defaultIndex", "vertical", "manual", "onChange", "selectedIndex"];

var _ne;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _, { Fragment as Y, createContext as O, useContext as k, useMemo as E, useReducer as Z, useRef as G } from "react";
import { render as D, Features as V, forwardRefWithAs as v } from "../../utils/render.js";
import { useId as q } from "../../hooks/use-id.js";
import { match as J } from "../../utils/match.js";
import { Keys as f } from "../../components/keyboard.js";
import { focusIn as S, Focus as m, sortByDomNode as Q } from "../../utils/focus-management.js";
import { useIsoMorphicEffect as j } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as F } from "../../hooks/use-sync-refs.js";
import { useResolveButtonType as ee } from "../../hooks/use-resolve-button-type.js";
import { useLatestValue as W } from "../../hooks/use-latest-value.js";
import { FocusSentinel as te } from "../../internal/focus-sentinel.js";
import { useEvent as U } from "../../hooks/use-event.js";

var re = function (n) {
  return n[n.SetSelectedIndex = 0] = "SetSelectedIndex", n[n.RegisterTab = 1] = "RegisterTab", n[n.UnregisterTab = 2] = "UnregisterTab", n[n.RegisterPanel = 3] = "RegisterPanel", n[n.UnregisterPanel = 4] = "UnregisterPanel", n[n.ForceRerender = 5] = "ForceRerender", n;
}(re || {});

var ne = (_ne = {}, _defineProperty(_ne, 0, function _(e, t) {
  var r = e.tabs.filter(function (n) {
    var l;
    return !((l = n.current) != null && l.hasAttribute("disabled"));
  });
  if (t.index < 0) return _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: e.tabs.indexOf(r[0])
  });
  if (t.index > e.tabs.length) return _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: e.tabs.indexOf(r[r.length - 1])
  });
  var s = e.tabs.slice(0, t.index),
      d = [].concat(_toConsumableArray(e.tabs.slice(t.index)), _toConsumableArray(s)).find(function (n) {
    return r.includes(n);
  });
  return d ? _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: e.tabs.indexOf(d)
  }) : e;
}), _defineProperty(_ne, 1, function _(e, t) {
  return e.tabs.includes(t.tab) ? e : _objectSpread(_objectSpread({}, e), {}, {
    tabs: Q([].concat(_toConsumableArray(e.tabs), [t.tab]), function (r) {
      return r.current;
    })
  });
}), _defineProperty(_ne, 2, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    tabs: Q(e.tabs.filter(function (r) {
      return r !== t.tab;
    }), function (r) {
      return r.current;
    })
  });
}), _defineProperty(_ne, 3, function _(e, t) {
  return e.panels.includes(t.panel) ? e : _objectSpread(_objectSpread({}, e), {}, {
    panels: [].concat(_toConsumableArray(e.panels), [t.panel])
  });
}), _defineProperty(_ne, 4, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    panels: e.panels.filter(function (r) {
      return r !== t.panel;
    })
  });
}), _defineProperty(_ne, 5, function _(e) {
  return _objectSpread({}, e);
}), _ne),
    N = O(null);
N.displayName = "TabsSSRContext";

function B(e) {
  var t = k(N);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, B), r;
  }

  return t;
}

var K = O(null);
K.displayName = "TabsDataContext";

function C(e) {
  var t = k(K);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, C), r;
  }

  return t;
}

var $ = O(null);
$.displayName = "TabsActionsContext";

function z(e) {
  var t = k($);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, z), r;
  }

  return t;
}

function ae(e, t) {
  return J(t.type, ne, e, t);
}

var le = Y,
    oe = v(function (t, r) {
  var _t$defaultIndex = t.defaultIndex,
      s = _t$defaultIndex === void 0 ? 0 : _t$defaultIndex,
      _t$vertical = t.vertical,
      b = _t$vertical === void 0 ? !1 : _t$vertical,
      _t$manual = t.manual,
      d = _t$manual === void 0 ? !1 : _t$manual,
      n = t.onChange,
      _t$selectedIndex = t.selectedIndex,
      l = _t$selectedIndex === void 0 ? null : _t$selectedIndex,
      P = _objectWithoutProperties(t, _excluded);

  var u = b ? "vertical" : "horizontal",
      y = d ? "manual" : "auto";

  var c = F(r),
      _Z = Z(ae, {
    selectedIndex: l != null ? l : s,
    tabs: [],
    panels: []
  }),
      _Z2 = _slicedToArray(_Z, 2),
      p = _Z2[0],
      o = _Z2[1],
      T = E(function () {
    return {
      selectedIndex: p.selectedIndex
    };
  }, [p.selectedIndex]),
      g = W(n || function () {}),
      L = W(p.tabs),
      x = E(function () {
    return _objectSpread({
      orientation: u,
      activation: y
    }, p);
  }, [u, y, p]),
      R = W(p.selectedIndex),
      h = E(function () {
    return {
      registerTab: function registerTab(i) {
        return o({
          type: 1,
          tab: i
        }), function () {
          return o({
            type: 2,
            tab: i
          });
        };
      },
      registerPanel: function registerPanel(i) {
        return o({
          type: 3,
          panel: i
        }), function () {
          return o({
            type: 4,
            panel: i
          });
        };
      },
      forceRerender: function forceRerender() {
        o({
          type: 5
        });
      },
      change: function change(i) {
        R.current !== i && g.current(i), R.current = i, o({
          type: 0,
          index: i
        });
      }
    };
  }, [o]);

  j(function () {
    o({
      type: 0,
      index: l != null ? l : s
    });
  }, [l]);
  var H = G({
    tabs: [],
    panels: []
  }),
      w = {
    ref: c
  };
  return _.createElement(N.Provider, {
    value: H
  }, _.createElement($.Provider, {
    value: h
  }, _.createElement(K.Provider, {
    value: x
  }, x.tabs.length <= 0 && _.createElement(te, {
    onFocus: function onFocus() {
      var i, I;

      var _iterator = _createForOfIteratorHelper(L.current),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var M = _step.value;
          if (((i = M.current) == null ? void 0 : i.tabIndex) === 0) return (I = M.current) == null || I.focus(), !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !1;
    }
  }), D({
    ourProps: w,
    theirProps: P,
    slot: T,
    defaultTag: le,
    name: "Tabs"
  }))));
}),
    se = "div",
    ie = v(function (t, r) {
  var _C = C("Tab.List"),
      s = _C.orientation,
      b = _C.selectedIndex,
      d = F(r);

  return D({
    ourProps: {
      ref: d,
      role: "tablist",
      "aria-orientation": s
    },
    theirProps: t,
    slot: {
      selectedIndex: b
    },
    defaultTag: se,
    name: "Tabs.List"
  });
}),
    ue = "button",
    ce = v(function (t, r) {
  var I, M;

  var s = "headlessui-tabs-tab-".concat(q()),
      _C2 = C("Tab"),
      b = _C2.orientation,
      d = _C2.activation,
      n = _C2.selectedIndex,
      l = _C2.tabs,
      P = _C2.panels,
      u = z("Tab"),
      y = B("Tab"),
      c = G(null),
      p = F(c, r, function (a) {
    !a || u.forceRerender();
  });

  j(function () {
    return u.registerTab(c);
  }, [u, c]);
  var o = y.current.tabs.indexOf(s);
  o === -1 && (o = y.current.tabs.push(s) - 1);
  var T = l.indexOf(c);
  T === -1 && (T = o);
  var g = T === n,
      L = U(function (a) {
    var A = l.map(function (X) {
      return X.current;
    }).filter(Boolean);

    if (a.key === f.Space || a.key === f.Enter) {
      a.preventDefault(), a.stopPropagation(), u.change(T);
      return;
    }

    switch (a.key) {
      case f.Home:
      case f.PageUp:
        return a.preventDefault(), a.stopPropagation(), S(A, m.First);

      case f.End:
      case f.PageDown:
        return a.preventDefault(), a.stopPropagation(), S(A, m.Last);
    }

    return J(b, {
      vertical: function vertical() {
        if (a.key === f.ArrowUp) return S(A, m.Previous | m.WrapAround);
        if (a.key === f.ArrowDown) return S(A, m.Next | m.WrapAround);
      },
      horizontal: function horizontal() {
        if (a.key === f.ArrowLeft) return S(A, m.Previous | m.WrapAround);
        if (a.key === f.ArrowRight) return S(A, m.Next | m.WrapAround);
      }
    });
  }),
      x = U(function () {
    var a;
    (a = c.current) == null || a.focus();
  }),
      R = U(function () {
    var a;
    (a = c.current) == null || a.focus(), u.change(T);
  }),
      h = U(function (a) {
    a.preventDefault();
  }),
      H = E(function () {
    return {
      selected: g
    };
  }, [g]),
      w = t,
      i = {
    ref: p,
    onKeyDown: L,
    onFocus: d === "manual" ? x : R,
    onMouseDown: h,
    onClick: R,
    id: s,
    role: "tab",
    type: ee(t, c),
    "aria-controls": (M = (I = P[T]) == null ? void 0 : I.current) == null ? void 0 : M.id,
    "aria-selected": g,
    tabIndex: g ? 0 : -1
  };
  return D({
    ourProps: i,
    theirProps: w,
    slot: H,
    defaultTag: ue,
    name: "Tabs.Tab"
  });
}),
    pe = "div",
    de = v(function (t, r) {
  var _C3 = C("Tab.Panels"),
      s = _C3.selectedIndex,
      b = F(r),
      d = E(function () {
    return {
      selectedIndex: s
    };
  }, [s]);

  return D({
    ourProps: {
      ref: b
    },
    theirProps: t,
    slot: d,
    defaultTag: pe,
    name: "Tabs.Panels"
  });
}),
    be = "div",
    Te = V.RenderStrategy | V.Static,
    fe = v(function (t, r) {
  var x, R;

  var _C4 = C("Tab.Panel"),
      s = _C4.selectedIndex,
      b = _C4.tabs,
      d = _C4.panels,
      n = z("Tab.Panel"),
      l = B("Tab.Panel"),
      P = "headlessui-tabs-panel-".concat(q()),
      u = G(null),
      y = F(u, r, function (h) {
    !h || n.forceRerender();
  });

  j(function () {
    return n.registerPanel(u);
  }, [n, u]);
  var c = l.current.panels.indexOf(P);
  c === -1 && (c = l.current.panels.push(P) - 1);
  var p = d.indexOf(u);
  p === -1 && (p = c);
  var o = p === s,
      T = E(function () {
    return {
      selected: o
    };
  }, [o]),
      g = t,
      L = {
    ref: y,
    id: P,
    role: "tabpanel",
    "aria-labelledby": (R = (x = b[p]) == null ? void 0 : x.current) == null ? void 0 : R.id,
    tabIndex: o ? 0 : -1
  };
  return D({
    ourProps: L,
    theirProps: g,
    slot: T,
    defaultTag: be,
    features: Te,
    visible: o,
    name: "Tabs.Panel"
  });
}),
    we = Object.assign(ce, {
  Group: oe,
  List: ie,
  Panels: de,
  Panel: fe
});
export { we as Tab };